import { Empty, Input, Tooltip, Pagination ,Select } from "antd";
import { TranslateString } from "Utils/Common";
import { UndoOutlined, EditOutlined } from "@ant-design/icons";
import moment from "moment";
// import { TenderStatus } from "constants/Constants";
import { BsArrowDownUp } from "react-icons/bs";
import { useState } from "react";

function DontTenderTenderingCases(props: any) {
  const [dontTenderSearchData, setDontTenderSearchData] = useState<any>(
    props.dontSearchData || {},
  );

  // const onSearch = (event: any) => {
  //     const { target } = event;
  //     const value = target.value;
  //     const { name } = target;

  //     setDontTenderSearchData({ ...dontTenderSearchData, [name]: value });
  // };

  // const onPressEnter = (event: any) => {
  //     props.setDontSearchData({ ...dontTenderSearchData });
  // };

  const onSearch = (e: any) => {
    const { name, value } = e.target;

    props.setDontSearchData((prev: any) => ({
      ...prev,
      [name]: value,
    }));
  };
  const onPressEnter = () => {
    props.setDontSearchData((prev: any) => ({ ...prev }));
  };

  return (
    <>
      <div className="mt-4 cu-table-border">
        <table className="table table-sm table-bordered table-striped text-left">
          <thead>
            <tr>
              <td colSpan={16} className="bg-white fw-bold fs-4">
                {TranslateString("dont_tender_tendering_cases")}
              </td>
            </tr>
            <tr className="align-middle cu-text-small">
              <td className="cu-bg-green fw-bold cu-three-width text-center">
                {TranslateString("priority")}
              </td>
              <td className="cu-bg-green fw-bold cu-three-width text-center">
                {TranslateString("tender_id")}
              </td>
              <td className="cu-bg-green fw-bold cu-three-width text-center">
                {TranslateString("customer_id")}
              </td>
              <td className="cu-bg-green fw-bold">
                {TranslateString("customer_name")}
              </td>
              <td className="cu-bg-green fw-bold">
                {TranslateString("loan_name")}
              </td>
              <td className="cu-bg-green fw-bold cu-three-width text-center">
                {TranslateString("loan_invoicing_model")}
              </td>
              <td className="cu-bg-green fw-bold cu-seven-width text-right">
                {TranslateString("current_capital")}
              </td>
              <td className="cu-bg-green fw-bold cu-five-width text-right">
                {TranslateString("margin")}
              </td>
              <td className="cu-bg-green fw-bold cu-three-width">
                {TranslateString("loaner_grouped")}
              </td>
              <td className="cu-bg-green fw-bold cu-three-width">
                {TranslateString("city")}
              </td>
              <td className="cu-bg-green fw-bold">
                {TranslateString("sännöitsijä")}
              </td>
              {/* <td className="cu-bg-green fw-bold">
                {TranslateString("housing_manager_comment")}
              </td>
              <td className="cu-bg-green fw-bold">
                {TranslateString("Kirjanpitäjä")}
              </td> */}
              <td className="cu-bg-green fw-bold">
                {TranslateString("Moderaattori")}
              </td>
              <td className="cu-bg-green fw-bold">
                {TranslateString("deadline")}
              </td>
              <td className="cu-bg-green fw-bold cu-ten-width">
                {TranslateString("tendering_notes")}
              </td>
              <td className="cu-bg-green fw-bold">
                {TranslateString("actions")}
              </td>
            </tr>
            <tr className="align-middle cu-text-small">
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setDontSearchData({
                          ...props.dontSearchData,
                          sort_by: "loan_data_priority",
                        });
                        props.setDontSort(!props.dontSort);
                      }}
                      role={"button"}
                    />
                  }
                  onChange={onSearch}
                  onPressEnter={onPressEnter}
                  name="loan_data_priority"
                />
              </td>
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  value={props.dontSearchData.loan_tender_id || ""}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setDontSearchData({
                          ...props.dontSearchData,
                          sort_by: "loan_tender_id",
                        });
                        props.setDontSort(!props.dontSort);
                      }}
                      role={"button"}
                    />
                  }
                  onChange={onSearch}
                  onPressEnter={onPressEnter}
                  name="loan_tender_id"
                />
              </td>
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  value={props.dontSearchData.loan_data_customerid || ""}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setDontSearchData({
                          ...props.dontSearchData,
                          sort_by: "loan_data_customerid",
                        });
                        props.setDontSort(!props.dontSort);
                      }}
                      role={"button"}
                    />
                  }
                  onChange={onSearch}
                  onPressEnter={onPressEnter}
                  name="loan_data_customerid"
                />
              </td>
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  value={props.dontSearchData.loan_data_customername || ""}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setDontSearchData({
                          ...props.dontSearchData,
                          sort_by: "loan_data_customername",
                        });
                        props.setDontSort(!props.dontSort);
                      }}
                      role={"button"}
                    />
                  }
                  onChange={onSearch}
                  onPressEnter={onPressEnter}
                  name="loan_data_customername"
                />
              </td>
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  value={props.dontSearchData.loan_data_name || ""}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setDontSearchData({
                          ...props.dontSearchData,
                          sort_by: "loan_data_name",
                        });
                        props.setDontSort(!props.dontSort);
                      }}
                      role={"button"}
                    />
                  }
                  onChange={onSearch}
                  onPressEnter={onPressEnter}
                  name="loan_data_name"
                />
              </td>
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  value={props.dontSearchData.loan_invoicing_model || ""}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setDontSearchData({
                          ...props.dontSearchData,
                          sort_by: "loan_invoicing_model",
                        });
                        props.setDontSort(!props.dontSort);
                      }}
                      role={"button"}
                    />
                  }
                  onChange={onSearch}
                  onPressEnter={onPressEnter}
                  name="loan_invoicing_model"
                />
              </td>
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  value={props.dontSearchData.loan_data_agreement || ""}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setDontSearchData({
                          ...props.dontSearchData,
                          sort_by: "loan_data_agreement",
                        });
                        props.setDontSort(!props.dontSort);
                      }}
                      role={"button"}
                    />
                  }
                  onChange={onSearch}
                  onPressEnter={onPressEnter}
                  name="loan_data_agreement"
                />
              </td>
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  value={props.dontSearchData.loan_data_margin || ""}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setDontSearchData({
                          ...props.dontSearchData,
                          sort_by: "loan_data_margin",
                        });
                        props.setDontSort(!props.dontSort);
                      }}
                      role={"button"}
                    />
                  }
                  onChange={onSearch}
                  onPressEnter={onPressEnter}
                  name="loan_data_margin"
                />
              </td>
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  value={props.dontSearchData.loan_data_bank_group || ""}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setDontSearchData({
                          ...props.dontSearchData,
                          sort_by: "loan_data_bank_group",
                        });
                        props.setDontSort(!props.dontSort);
                      }}
                      role={"button"}
                    />
                  }
                  onChange={onSearch}
                  onPressEnter={onPressEnter}
                  name="loan_data_bank_group"
                />
              </td>
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  value={props.dontSearchData.cust_data_city || ""}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setDontSearchData({
                          ...props.dontSearchData,
                          sort_by: "cust_data_city",
                        });
                        props.setDontSort(!props.dontSort);
                      }}
                      role={"button"}
                    />
                  }
                  onChange={onSearch}
                  onPressEnter={onPressEnter}
                  name="cust_data_city"
                />
              </td>
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  value={props.dontSearchData.cust_data_manager_name || ""}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setDontSearchData({
                          ...props.dontSearchData,
                          sort_by: "cust_data_manager_name",
                        });
                        props.setDontSort(!props.dontSort);
                      }}
                      role={"button"}
                    />
                  }
                  onChange={onSearch}
                  onPressEnter={onPressEnter}
                  name="cust_data_manager_name"
                />
              </td>
              {/* <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  value={props.dontSearchData.hm_comment || ""}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setDontSearchData({
                          ...props.dontSearchData,
                          sort_by: "hm_comment",
                        });
                        props.setDontSort(!props.dontSort);
                      }}
                      role={"button"}
                    />
                  }
                  onChange={onSearch}
                  onPressEnter={onPressEnter}
                  name="hm_comment"
                />
              </td>
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  value={props.dontSearchData.accountant_name || ""}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setDontSearchData({
                          ...props.dontSearchData,
                          sort_by: "accountant_name",
                        });
                        props.setDontSort(!props.dontSort);
                      }}
                      role={"button"}
                    />
                  }
                  onChange={onSearch}
                  onPressEnter={onPressEnter}
                  name="accountant_name"
                />
              </td> */}
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  value={props.dontSearchData.created_by || ""}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setDontSearchData({
                          ...props.dontSearchData,
                          sort_by: "created_by",
                        });
                        props.setDontSort(!props.dontSort);
                      }}
                      role={"button"}
                    />
                  }
                  onChange={onSearch}
                  onPressEnter={onPressEnter}
                  name="created_by"
                />
              </td>
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  value={props.dontSearchData.loan_tender_deadline || ""}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setDontSearchData({
                          ...props.dontSearchData,
                          sort_by: "loan_tender_deadline",
                        });
                        props.setDontSort(!props.dontSort);
                      }}
                      role={"button"}
                    />
                  }
                  onChange={onSearch}
                  onPressEnter={onPressEnter}
                  name="loan_tender_deadline"
                />
              </td>
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  value={props.dontSearchData.loan_tender_notes || ""}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setDontSearchData({
                          ...props.dontSearchData,
                          sort_by: "loan_tender_notes",
                        });
                        props.setDontSort(!props.dontSort);
                      }}
                      role={"button"}
                    />
                  }
                  onChange={onSearch}
                  onPressEnter={onPressEnter}
                  name="loan_tender_notes"
                />
              </td>
              <td className="cu-bg-green"></td>
            </tr>
          </thead>
          <tbody className="cu-text-small">
            {props?.tenderData?.getDontTender?.length > 0 ? (
              props?.tenderData?.getDontTender?.map((val: any) => {
                return (
                  <tr>
                    <td className="text-center fw-bold">
                      {val?.LOAN_DATA?.loan_data_priority || "-"}
                    </td>
                    <td className="text-center fw-bold">
                      {val?.loan_tender_id || "-"}
                    </td>
                    <td className="text-center fw-bold">
                      {val?.LOAN_DATA?.loan_data_customerid || "-"}
                    </td>
                    <td>{val?.LOAN_DATA?.loan_data_customername || "-"}</td>
                    <td>
                      {val?.LOAN_DATA?.loan_data_name?.replace(
                        "Uusi laina:",
                        TranslateString("new_loan"),
                      ) || "-"}
                    </td>
                    <td className="text-center">
                      {val?.LOAN_DATA?.loan_invoicing_model || "-"}
                    </td>
                    <td className="text-right fw-bold text-nowrap">
                      {val?.LOAN_DATA?.loan_data_agreement || "-"}
                    </td>
                    <td className="text-right fw-bold text-nowrap">
                      {val?.LOAN_DATA?.loan_data_margin || "-"}
                    </td>
                    <td>{val?.LOAN_DATA?.loan_data_bank_group || "-"}</td>
                    <td>{val?.LOAN_DATA?.CUST_DATA?.cust_data_city || "-"}</td>
                    <td>
                      {val?.LOAN_DATA?.CUST_DATA?.cust_data_manager_name || "-"}
                    </td>
                    {/* <td>{val?.hm_comment || "-"}</td>
                    <td>{val?.LOAN_DATA?.CUST_DATA?.accountant_name || "-"}</td> */}
                    <td>{val?.created_by || "-"}</td>
                    <td>
                      {val?.loan_tender_deadline
                        ? moment(val?.loan_tender_deadline).format("DD.MM.YYYY")
                        : "-"}
                    </td>
                    <td>{val?.loan_tender_notes || "-"}</td>
                    <td className="text-center" role="button">
                      <div className="d-flex">
                        <div>
                          <Tooltip title={TranslateString("revert")}>
                            <UndoOutlined
                              onClick={() => props.handleRevert(val)}
                              className="m-0 cu-font-bold cu-font-cancel"
                            />
                          </Tooltip>
                        </div>
                        <div>&nbsp;</div>
                        <div>
                          <Tooltip title={TranslateString("edit")}>
                            <EditOutlined
                              className="fs-5"
                              onClick={() => {
                                props.setDeadlineRequired(true);
                                props.setNotesRequired(true);
                                props.handleEdit(val);
                              }}
                            />
                          </Tooltip>
                        </div>
                      </div>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={17}>
                  <Empty description={TranslateString("Empty")} />
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {/* <div className="d-flex justify-content-end mt-3">
        <div>
          {`${(props.dontPageData?.page || 0) * (props.dontPageData?.size || 50) + 1}
      -
      ${Math.min(
        ((props.dontPageData?.page || 0) + 1) *
          (props.dontPageData?.size || 50),
        props.dontTotalRecords || 0,
      )}
      of ${props.dontTotalRecords || 0} items`}
        </div>

        <Pagination
          current={(props.dontPageData?.page || 0) + 1}
          pageSize={props.dontPageData?.size || 50}
          total={props.dontTotalRecords || 0}
          showSizeChanger
          onChange={(page, pageSize) => {
            props.setDontPageData({
              page: page - 1,
              size: pageSize,
            });
          }}
        />
      </div> */}
       {/* <div className="d-flex justify-content-end mt-3">
           <div>
    {`${((props.dontPageData?.page || 0) * (props.dontPageData?.size || 50)) + 1}
      -
      ${Math.min(
        ((props.dontPageData?.page || 0) + 1) *
          (props.dontPageData?.size || 50),
        props.dontTotalRecords || 0
      )}
      of ${props.dontTotalRecords || 0} items`}
  </div>

  <Pagination
  current={(props.dontPageData?.page || 0) + 1}
  pageSize={props.dontPageData?.size || 50}
  total={props.dontTotalRecords || 0}
  showSizeChanger
  onChange={(page, pageSize) => {
    props.setDontPageData({
      page: page - 1,
      size: pageSize,
    });
  }}
/>
</div> */}
<div className="d-flex justify-content-end align-items-center gap-3 mt-3">
  <div>
    {props.dontPageData?.size === -1
      ? `1 - ${props.dontTotalRecords} of ${props.dontTotalRecords} items`
      : `${((props.dontPageData?.page || 0) * (props.dontPageData?.size || 50)) + 1}
        -
        ${Math.min(
          ((props.dontPageData?.page || 0) + 1) *
            (props.dontPageData?.size || 50),
          props.dontTotalRecords || 0
        )}
        of ${props.dontTotalRecords || 0} items`}
  </div>

  

  <Pagination
    current={
      props.dontPageData?.size === -1
        ? 1
        : (props.dontPageData?.page || 0) + 1
    }
    pageSize={
      props.dontPageData?.size === -1
        ? props.dontTotalRecords
        : props.dontPageData?.size
    }
    total={props.dontTotalRecords || 0}
    showSizeChanger={false}
    onChange={(page) => {
      props.setDontPageData({
        page: page - 1,
        size: props.dontPageData?.size,
      });
    }}
  />
  <Select
    style={{ width: 100 }}
    value={props.dontPageData?.size}
    onChange={(value) => {
      props.setDontPageData({
        page: 0,
        size: value,
      });
    }}
    options={[
      { label: "10", value: 10 },
      { label: "20", value: 20 },
      { label: "50", value: 50 },
      { label: "100", value: 100 },
      { label: "All", value: -1 },
    ]}
  />
</div>
    </>
  );
}
export default DontTenderTenderingCases;
